// extracted by mini-css-extract-plugin
export default {"doc-link":"bK7hoZSb1z","docLink":"bK7hoZSb1z"};